import type { FC, PropsWithChildren, ReactElement } from "react";
import React from "react";

import "./styles.scss";

type Props = any;

export const GeneralLayout: FC<Props> = (props: PropsWithChildren<Props>) => {
    const element = props.children as ReactElement;

    return (
        <div className="general-layout">
            <div className="general-layout__content">
                <div className="general-layout__content-container">
                    <element.type {...element.props} />
                </div>
            </div>
        </div>
    );
};
